export type {
  AvatarGroupPopoverProps,
  AvatarGroupPopoverSlots,
  AvatarGroupPopoverState,
  AvatarGroupPopoverBaseProps,
  AvatarGroupPopoverBaseState,
} from './components/AvatarGroupPopover/index';
export {
  AvatarGroupPopover,
  avatarGroupPopoverClassNames,
  renderAvatarGroupPopover_unstable,
  useAvatarGroupPopoverContextValues_unstable,
  useAvatarGroupPopoverStyles_unstable,
  useAvatarGroupPopover_unstable,
  useAvatarGroupPopoverBase_unstable,
} from './components/AvatarGroupPopover/index';
